import '@khmyznikov/pwa-install';
import type { JSX } from 'preact';

/**
 * Install prompt, delegated to the @khmyznikov/pwa-install web component.
 *
 * It covers everything the previous hand-rolled banner did and more:
 * captures Chromium's `beforeinstallprompt` for a rich install dialog
 * (name, icon, description and screenshots from the manifest), shows
 * platform-native "Add to Home Screen / Dock" instructions on iOS, iPadOS
 * and macOS Safari where no install API exists, offers manual instructions
 * on Firefox/Opera, hides itself when already running standalone, and
 * remembers dismissal via localStorage.
 *
 * Deliberately no name/description/icon attributes: the component reads
 * them from the web app manifest, which is the single source of truth.
 */
export function InstallPrompt(): JSX.Element {
  return <pwa-install use-local-storage />;
}
